import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createtopper, updatetopper, gettopper, deletetoppers } from '../../ReduxToolkit/Slice/Academic/Topper';
import JoditEditor from 'jodit-react';
import { ToastContainer } from "react-toastify";
import CommanTable from '../../components/Table/CommanTable';



function Topper() {
    const dispatch = useDispatch();
    const closeButtonRef = useRef(null);
    const { status, toppers } = useSelector((state) => state.topper);
    const [Image, setImage] = useState(null);
    const [Name, setName] = useState("");
    const [Batch, setBatch] = useState("");
    const [marks, setMarks] = useState("");
    const [year, setYear] = useState("");
    const [content, setContent] = useState("");
    const [isDescriptionValid, setIsDescriptionValid] = useState(true);

    // create
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!content) {
            setIsDescriptionValid(false);
            alert("Description is required")
            return;

        }
        setIsDescriptionValid(true);
        const formData = new FormData();
        formData.append('Image', Image === null ? "" : Image);
        formData.append('Name', Name);
        formData.append('Batch', Batch);
        formData.append('marks', marks);
        formData.append('year', year);
        formData.append('content', content);
        dispatch(createtopper(formData));
        closeButtonRef.current.click();
        setImage(null);
        setName("");
        setBatch("");
        setYear("");
        setMarks("");
        setContent("");
    };
    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(gettopper())
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (topperid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this topper?")
        if (Isconfirmed) {
            dispatch(deletetoppers(topperid))
        };
    }
    // single data fetch
    const [selectedId, setSelectedId] = useState(null);
    const handlid = (id) => {
        const selectetopper = toppers.data.find(topper => topper._id === id);
        setName(selectetopper.Name);
        setBatch(selectetopper.Batch);
        setMarks(selectetopper.marks);
        setYear(selectetopper.year);
        setImage(selectetopper.Image);
        setContent(selectetopper.content);
        setSelectedId(id);
    };
    // update
    const handleEdit = (e) => {
        e.preventDefault()
        const formData = new FormData();
        formData.append('Image', Image === null ? "" : Image);
        formData.append('Name', Name);
        formData.append('Batch', Batch);
        formData.append('marks', marks);
        formData.append('year', year);
        formData.append('content', content);
        dispatch(updatetopper({ selectedId, formData }));
        closeButtonRef.current.click();
        setImage(null);
        setName("");
        setBatch("");
        setYear("");
        setYear("");
        setContent("");
    }
    function formatDate(dateString) {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined,
        );
      }
    
    const columns = [
        { label: "Name", accessor: "Name" },
        { label: "Batch", accessor: "Batch" },
        { label: "Marks", accessor: "marks" },
        { label: "Year", accessor: "year" },    
        { label: "content", accessor: "content" },
        { label: "Date", accessor: "createdAt", formatter: formatDate },
      ];
    return (
        <>
            <div>
            <ToastContainer />
                <div className='d-flex justify-content-between my-3'>
                    <h3>Acadamic</h3>
                    <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal"><i className='bi bi-plus-circle-fill'></i>  Toppers </button>
                </div>
               
                <CommanTable
          columns={columns}
          data={toppers.data || []}
          status={status}
          onDelete={handleDelete}
          onEdit={handlid}
          databstarget="#exampleModalEdit"
          model="modal"
        />
            </div>

            {/* Modal upload  */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Upload topper
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="Name" className="form-label">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="Name"
                                            name="Name"
                                            value={Name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder="Name"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="Batch" className="form-label">
                                            Batch
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="Batch"
                                            name="Batch"
                                            value={Batch}
                                            onChange={(e) => setBatch(e.target.value)}
                                            placeholder="Batch"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="Marks" className="form-label">
                                            Marks
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="Marks"
                                            name="Marks"
                                            value={marks}
                                            onChange={(e) => setMarks(e.target.value)}
                                            placeholder="Marks"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="year" className="form-label">
                                            Year
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="year"
                                            name="year"
                                            value={year}
                                            onChange={(e) => setYear(e.target.value)}
                                            placeholder="year"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">

                                        <label htmlFor="Image" className="form-label">
                                            Image
                                        </label>
                                        <input
                                            required
                                            type="file"
                                            className="form-control"
                                            id="Image"
                                            name="Image"
                                            // value={thumbnail}
                                            onChange={(e) => setImage(e.target.files[0])}
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-12">
                                        <label htmlFor="content" className="form-label">
                                            Content
                                        </label>
                                        <JoditEditor
                                            required={true}
                                            value={content}
                                            tabIndex={1} // 
                                            onBlur={newdescription => setContent(newdescription)}
                                            onChange={newdescription => { }}
                                        />
                                    </div>
                                    <div className={`modal-footer`}>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-dismiss="modal"
                                            ref={closeButtonRef}
                                        >
                                            Close
                                        </button>

                                        <button type="submit" className={`btn btn-primary`} >
                                            Upload
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal Edit  */}
            <div
                className="modal fade"
                id="exampleModalEdit"
                tabIndex={-1}
                aria-labelledby="exampleModalLabeledit"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabeledit">
                                Update topper Deatails
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleEdit}>
                                <div className="row">
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="Name" className="form-label">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="Name"
                                            name="Name"
                                            value={Name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder="Name"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="Batch" className="form-label">
                                            Batch
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="Batch"
                                            name="Batch"
                                            value={Batch}
                                            onChange={(e) => setBatch(e.target.value)}
                                            placeholder="Batch"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="Marks" className="form-label">
                                            Marks
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="Marks"
                                            name="Marks"
                                            value={marks}
                                            onChange={(e) => setMarks(e.target.value)}
                                            placeholder="Marks"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="year" className="form-label">
                                            Year
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="year"
                                            name="year"
                                            value={year}
                                            onChange={(e) => setYear(e.target.value)}
                                            placeholder="year"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">

                                        <label htmlFor="Image" className="form-label">
                                            Image
                                        </label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="Image"
                                            name="Image"
                                            // value={thumbnail}
                                            onChange={(e) => setImage(e.target.files[0])}
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-12">
                                        <label htmlFor="content" className="form-label">
                                            Content
                                        </label>
                                        <JoditEditor
                                            required={true}
                                            value={content}
                                            tabIndex={1} // 
                                            onBlur={newdescription => setContent(newdescription)}
                                            onChange={newdescription => { }}
                                        />
                                    </div>
                                    <div className={`modal-footer`}>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-dismiss="modal"
                                            ref={closeButtonRef}
                                        >
                                            Close
                                        </button>

                                        <button type="submit" className={`btn btn-primary`} >
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Topper;
